<div
  class="layout-sidebar"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
>
  <div class="sidebar-header">
    <a [routerLink]="['/']" class="app-logo">
      <img
        src="../../assets/site/brightsidelogo.png"
        alt=""
        class="app-logo-normal"
      />
    </a>
  </div>

  <div #menuContainer class="layout-menu-container">
    <app-menu></app-menu>
  </div>

  <div class="sidebar-footer">
    <button
      type="button"
      class="sidebar-tutorial-btn"
      (click)="startTutorial()"
    >
      <i class="pi pi-question-circle"></i>
      <span>Tutorial</span>
    </button>
    <div class="sidebar-legal-links">
      <a routerLink="/legal/terms-of-service" class="sidebar-legal-link">
        Terms of Service
      </a>
      <span class="sidebar-separator">•</span>
      <a routerLink="/legal/privacy-policy" class="sidebar-legal-link">
        Privacy Policy
      </a>
    </div>
  </div>
</div>
